// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface PublicationRead
 */
export interface PublicationRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  description?: string;
  /**
   *
   */
  publishedVersion?: number | null;
  /**
   *
   */
  files?: Array<any>;
  /**
   *
   */
  fileDescriptors?: Array<any>;
  /**
   *
   */
  creator: User;
}

/**
 * Check if a given object implements the PublicationRead interface.
 */
export function instanceOfPublicationRead(value: object): value is PublicationRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("projectId" in (value as Record<string, any>)) &&
      !("project_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectId"] === undefined &&
      (value as Record<string, any>)["project_id"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  return true;
}

export function PublicationReadFromJSON(json: any): PublicationRead {
  return PublicationReadFromJSONTyped(json, false);
}

export function PublicationReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    projectId: json["project_id"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    publishedVersion:
      json["published_version"] === undefined
        ? undefined
        : json["published_version"] === null
        ? null
        : json["published_version"],
    files: json["files"] == null ? undefined : json["files"],
    fileDescriptors: json["file_descriptors"] == null ? undefined : json["file_descriptors"],
    creator: UserFromJSON(json["creator"]),
  };
}

export function PublicationReadToJSON(json: any): PublicationRead {
  return PublicationReadToJSONTyped(json, false);
}

export function PublicationReadToJSONTyped(
  value?: PublicationRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    project_id: value["projectId"],
    name: value["name"],
    description: value["description"],
    published_version: value["publishedVersion"],
    files: value["files"],
    file_descriptors: value["fileDescriptors"],
    creator: UserToJSON(value["creator"]),
  };
}
